"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.array.sort");require("core-js/modules/es6.number.constructor");var _defineProperty2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty"));












































































































































































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {var _addData, _defaultData;return { tableData: [], // 列表数据
      droplist: [], imageSrcList: [], typelist: [{ name: '固定', value: 1 }, { name: '组合', value: 2 }], isNewProgramArr: [{ value: '0', name: '否' }, { value: '1', name: '是' }], searchData: { name: '', typeCode: '', type: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: (_addData = { id: '', bluetooth: '', command: '', description: '', selectedImage: '', image: '', phoneSelectedImage: '', phoneImage: '' }, (0, _defineProperty2.default)(_addData, "image", ''), (0, _defineProperty2.default)(_addData, "intensity", ''), (0, _defineProperty2.default)(_addData, "sort", ''), (0, _defineProperty2.default)(_addData, "name", ''), (0, _defineProperty2.default)(_addData, "remarks", ''), (0, _defineProperty2.default)(_addData, "type", ''), (0, _defineProperty2.default)(_addData, "typeCode", ''), (0, _defineProperty2.default)(_addData, "isNewProgram", '0'), _addData), defaultData: (_defaultData = { id: '', bluetooth: '', command: '', description: '', selectedImage: '', image: '', phoneSelectedImage: '', phoneImage: '' }, (0, _defineProperty2.default)(_defaultData, "image", ''), (0, _defineProperty2.default)(_defaultData, "intensity", ''), (0, _defineProperty2.default)(_defaultData, "sort", ''), (0, _defineProperty2.default)(_defaultData, "name", ''), (0, _defineProperty2.default)(_defaultData, "remarks", ''), (0, _defineProperty2.default)(_defaultData, "type", ''), (0, _defineProperty2.default)(_defaultData, "typeCode", ''), (0, _defineProperty2.default)(_defaultData, "isNewProgram", '0'), _defaultData), // 表格列
      tableColumns: [{ prop: 'name', label: '指令名称', isShow: true }, { prop: '蓝牙命令', label: 'bluetooth', isShow: false }, { prop: 'command', label: 'wifi指令', isShow: true }, { prop: 'intensity', label: '按摩力度', isShow: true }, { prop: 'typeCode', label: '设备类型', isShow: true }, { prop: 'type', label: '指令类型', formatter: _formatter.typeFormatter, isShow: true }, { prop: 'remarks', label: '说明文字', isShow: true }, { prop: 'description', label: '版本', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'operatorName', label: '操作人', isShow: true }], rules: { sort: [{ required: true, message: '请输入序号', trigger: 'blur' }], name: [{ required: true, message: '请输入指令名称', trigger: 'blur' }], bluetooth: [{ required: true, message: '请输入蓝牙命令', trigger: 'blur' }, { type: 'number', message: '请输入数字类型', trigger: 'blur', transform: function transform(value) {return Number(value);} // 将输入框的value值转为number类型
        }], image: [{ required: true, message: '请上传平板手控器未选中图标', trigger: 'change' }], phoneImage: [{ required: true, message: '请上传移动端未选中图标', trigger: 'change' }], command: [{ required: true, message: '请输入wifi指令', trigger: 'blur' }], intensity: [{ required: true, message: '请输入按摩力度', trigger: 'blur' }, { type: 'number', message: '请输入数字类型', transform: function transform(value) {return Number(value);} // 将输入框的value值转为number类型
        }], typeCode: [{ required: true, message: '请选择设备类型', trigger: 'blur' }], type: [{ required: true, message: '请选择指令类型', trigger: 'blur' }], remarks: [{ required: true, message: '请输入说明文字', trigger: 'blur' }], description: [{ required: true, message: '请输入版本号', trigger: 'blur' }, { pattern: /^-?\d+\.\d+$/, message: '请输入数字型的版本号' }] } };}, mounted: function mounted() {var self = this;self.init();self.getdrop();}, methods: { init: function init() {var self = this;self.getData('/api/faProgram/', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, // 设置imageList
    setImageList: function setImageList(val) {var arr = [];if (val) {arr.push(val);} // 深拷贝
      this.imageSrcList = Object.assign([], arr); // 强刷--不建议
      // this.$forceUpdate()
    }, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.typeCode = '';this.searchData.type = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faProgram/del/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();done();}, onSubmit: function onSubmit() {var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {var parems = new FormData();parems.append('bluetooth', self.addData.bluetooth);parems.append('sort', self.addData.sort);parems.append('name', self.addData.name);parems.append('remarks', self.addData.remarks);parems.append('selectedImage', self.addData.selectedImage);parems.append('image', self.addData.image);parems.append('phoneSelectedImage', self.addData.phoneSelectedImage);parems.append('phoneImage', self.addData.phoneImage);parems.append('command', self.addData.command);parems.append('description', self.addData.description);parems.append('intensity', self.addData.intensity);parems.append('type', self.addData.type);parems.append('typeCode', self.addData.typeCode);parems.append('isNewProgram', self.addData.isNewProgram);self.postData('/api/faProgram', parems, function (res) {self.$message({ message: '添加成功!', type: 'success' });self.onCencal();self.searchData.page = 1;self.init();});} else {return false;}});}, updateMenu: function updateMenu(item) {var _this$addData;this.title = '编辑';var self = this;this.addData = (_this$addData = { id: item.id, remarks: item.remarks, bluetooth: item.bluetooth, sort: item.sort, name: item.name, command: item.command, image: item.image, selectedImage: item.selectedImage,
        phoneSelectedImage: item.phoneSelectedImage,
        phoneImage: item.phoneImage }, (0, _defineProperty2.default)(_this$addData, "image",
      item.image), (0, _defineProperty2.default)(_this$addData, "description",
      item.description), (0, _defineProperty2.default)(_this$addData, "intensity",
      item.intensity), (0, _defineProperty2.default)(_this$addData, "type",
      item.type), (0, _defineProperty2.default)(_this$addData, "typeCode",
      item.typeCode), (0, _defineProperty2.default)(_this$addData, "isNewProgram",
      item.isNewProgram + ''), _this$addData);

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var parems = new FormData();
          /**
                                        * 图片回显问题：
                                        *  一直在考虑把阿里云oss图片url转为base64但是遇到了问题一直不能实现，仔细一想，为啥图片回显我要把url转成base64呢，为了重新上传图片？
                                        *  完全不需要啊，只要在提交时判断是否有换图片就ok了，如果没有换图片就不需要传图片，这也解决了重复上传图片的问题
                                        */
          parems.append('id', self.addData.id);
          parems.append('bluetooth', self.addData.bluetooth);
          parems.append('sort', self.addData.sort);
          parems.append('name', self.addData.name);
          parems.append('remarks', self.addData.remarks);
          parems.append('selectedImage', self.addData.selectedImage);
          parems.append('image', self.addData.image);
          parems.append('phoneSelectedImage', self.addData.phoneSelectedImage);
          parems.append('phoneImage', self.addData.phoneImage);
          parems.append('command', self.addData.command);
          parems.append('description', self.addData.description);
          parems.append('intensity', self.addData.intensity);
          parems.append('typeCode', self.addData.typeCode);
          parems.append('type', self.addData.type);
          parems.append('isNewProgram', self.addData.isNewProgram);
          self.postData('/api/faProgram', parems, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
            // 清空数据
            self.addData = {};
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    getFile: function getFile(file, fileList) {
      var self = this;
      self.getFileByBase64(file.raw).then(function (res) {
        self.addData.selectedImage = res;
      });
    },
    getFileByBase64: function getFileByBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'iot/instruct';
      _aliOss.default.ossUploadFile(option, path);
      console.log('res.name:', option.name);
    },
    beforeRemove: function beforeRemove(file, fileList) {
      var fileName = file.name;
      var confirm = '确定移除' + fileName + '?';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      this.addData.filePath = '';
      this.$message('移除' + file.name + '成功');
    },
    onsuccess: function onsuccess(res) {
      console.log('res:', res);
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.selectedImage = fileUrl;
      console.log('filePath:', fileUrl);
    },
    onsuccess2: function onsuccess2(res) {
      console.log('res:', res);
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.image = fileUrl;
      console.log('filePath:', fileUrl);
    },
    onsuccess3: function onsuccess3(res) {
      console.log('res:', res);
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.phoneSelectedImage = fileUrl;
      console.log('filePath:', fileUrl);
    },
    onsuccess4: function onsuccess4(res) {
      console.log('res:', res);
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.phoneImage = fileUrl;
      console.log('filePath:', fileUrl);
    },
    handleChangePic: function handleChangePic(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
    } } };exports.default = _default;